document.addEventListener('click', function (event) {
  var toggleBtn = event.target.closest('[data-size-chart-toggle]');

  if (toggleBtn) {
    var chart = toggleBtn.closest('[data-size-chart]');
    var content = chart && chart.querySelector('[data-size-chart-content]');

    if (content) {
      var isHidden = content.hasAttribute('hidden');

      if (isHidden) {
        content.removeAttribute('hidden');
      } else {
        content.setAttribute('hidden', '');
      }

      var icon = toggleBtn.querySelector('.impuria-fit-size-chart__toggle-icon');
      if (icon) {
        icon.textContent = isHidden ? '−' : '+';
      }

      toggleBtn.classList.toggle('is-open', isHidden);
    }

    return;
  }

  var unitBtn = event.target.closest('[data-size-units-toggle]');

  if (unitBtn) {
    var units = unitBtn.getAttribute('data-units');
    var group = unitBtn.closest('.impuria-fit-size-chart__units');

    if (group) {
      group.querySelectorAll('[data-size-units-toggle]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn === unitBtn);
      });
    }

    var chartRoot = unitBtn.closest('[data-size-chart]');

    if (chartRoot) {
      chartRoot.querySelectorAll('[data-units-cell]').forEach(function (cell) {
        var value = units === 'in' ? cell.getAttribute('data-in') : cell.getAttribute('data-mm');
        if (value !== null) {
          cell.innerHTML = value;
        }
      });
    }
  }
});

/* ==============================================================================================
   SIZE GUIDE DRAWER
   ==============================================================================================
   Opens the fit guide over the page instead of inline. Delegated from document like the size-chart
   handlers above, so it needs no per-instance wiring.
   ============================================================================================== */
(function () {
  var CLOSE_MS = 320; // must outlast the panel transition in will-it-fit.css
  var openDrawer = null;
  var lastTrigger = null;
  var closeTimer = null;

  function focusables(root) {
    return Array.prototype.filter.call(
      root.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null || el === document.activeElement; }
    );
  }

  function open(drawer, trigger) {
    if (!drawer || openDrawer === drawer) return;
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }

    lastTrigger = trigger || null;
    openDrawer = drawer;

    drawer.removeAttribute('hidden');
    // Next frame, so the browser has a painted start state to transition from.
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });

    document.documentElement.classList.add('size-guide-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    var closeBtn = drawer.querySelector('[data-size-guide-close]');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!openDrawer) return;
    var drawer = openDrawer;
    openDrawer = null;

    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('size-guide-open');

    // Hidden only once the slide-out has finished, otherwise it would vanish instead of sliding.
    closeTimer = setTimeout(function () {
      drawer.setAttribute('hidden', '');
      closeTimer = null;
    }, CLOSE_MS);

    if (lastTrigger) {
      lastTrigger.setAttribute('aria-expanded', 'false');
      // Focus goes back to the button that opened it, not to the top of the document.
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-size-guide-open]');
    if (trigger) {
      event.preventDefault();
      var id = trigger.getAttribute('aria-controls');
      open(id ? document.getElementById(id) : document.querySelector('[data-size-guide]'), trigger);
      return;
    }

    if (event.target.closest('[data-size-guide-close]') || event.target.closest('[data-size-guide-overlay]')) {
      event.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!openDrawer) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }

    // Keep Tab inside the dialog while it is modal.
    if (event.key === 'Tab') {
      var items = focusables(openDrawer);
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
})();
